import { render } from "./CookiePage.vue?vue&type=template&id=1f02ffc6&scoped=true"
import script from "./CookiePage.vue?vue&type=script&lang=js"
export * from "./CookiePage.vue?vue&type=script&lang=js"

import "./CookiePage.vue?vue&type=style&index=0&id=1f02ffc6&scoped=true&lang=css"

import exportComponent from "/Users/derem1991/workspace/newear/frontend/theearcasino/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f02ffc6"]])

export default __exports__